<template>
  <qvoButton text @click="logout">Logout</qvoButton>
</template>

<script>
/**
 * @fileoverview Profile Icon
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import qvoButton from "@/qux-common/qux22/components/molecules/button";

export default {
  components: {
    qvoButton,
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>